import axios from "axios";
import useGlobale from './global';
import { toast } from 'react-toastify';

const api = axios.create({
    baseURL: 'https://datacollectbackend.aysdevs.com',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    withCredentials: false
});

// Function to handle logout and show message
const handleLogout = async (message) => {
    const { logout } = useGlobale.getState();
    await logout();
    toast.error(message || "Votre session a expiré. Veuillez vous reconnecter.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    });
};

// Intercepteur pour ajouter le token aux requêtes
api.interceptors.request.use(async (config) => {
    const tokensString = localStorage.getItem('auth_tokens');
    if (tokensString) {
        const tokens = JSON.parse(tokensString);
        if (tokens.access) {
            config.headers['Authorization'] = `Bearer ${tokens.access}`;
        }
    }
    return config;
});

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401) {
            // Si c'est une erreur 401 sur la route de login, on ne fait rien
            if (error.config.url === '/utilisateur/login/') {
                return Promise.reject(error);
            }
            
            // Pour les autres routes, on gère la déconnexion
            await handleLogout("Session invalide. Veuillez vous reconnecter.");
        }
        return Promise.reject(error);
    }
);

export default api;